import styled from "styled-components";
import {auroraBackground, overlayGradient, pageBackdrop, panelGradient} from "./tokens";

/**
 * Reusable v3 page-backdrop layers, extracted from the design source. All colors come from
 * `theme.tokens`, so every backdrop follows light/dark mode automatically.
 *
 * Layering recipe from the design: a positioned container gets a `PageBackdrop` (dotted paper)
 * with an `AuroraBackdrop` inside it for the soft brand glow; the panel-active/transfer state swaps
 * in the vivid `PanelBackdrop`; full-screen takeovers use `OverlayBackdrop`.
 */

/** Dotted-paper page backdrop (design `.bg`): paper color + 24px dot grid. */
export const PageBackdrop = styled.div`
	position: absolute;
	inset: 0;
	overflow: hidden;
	z-index: 0;
	background-color: ${({theme}) => pageBackdrop(theme.tokens).backgroundColor};
	background-image: ${({theme}) => pageBackdrop(theme.tokens).backgroundImage};
	background-size: 24px 24px;
	background-position: -12px -12px;
`;

/** Soft aurora glow layer (design `.aurora`). Place inside a positioned, overflow-hidden parent. */
export const AuroraBackdrop = styled.div`
	position: absolute;
	inset: -30%;
	z-index: 0;
	pointer-events: none;
	opacity: ${({theme}) => (theme.tokens.mode === "dark" ? 0.55 : 0.9)};
	filter: blur(72px) saturate(${({theme}) => (theme.tokens.mode === "dark" ? 1 : 1.1)});
	background: ${({theme}) => auroraBackground(theme.tokens)};
`;

/** Vivid blue→teal backdrop for the panel-active state (design `.overlay`, 04-state). */
export const PanelBackdrop = styled.div`
	position: absolute;
	inset: 0;
	background: ${({theme}) => panelGradient(theme.tokens)};
`;

/** Fixed full-screen gradient wash with blur, for takeover overlays (design `.overlay`). */
export const OverlayBackdrop = styled.div`
	position: fixed;
	inset: 0;
	background: ${overlayGradient};
	backdrop-filter: blur(8px);
`;
